import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export async function fetchConfig() {
  try {
    const res = await axios.get(`${API}/config`);
    return !!res.data.is_post_launch;
  } catch {
    return false;
  }
}

export async function fetchWaitlistCount() {
  try {
    const res = await axios.get(`${API}/waitlist/count`);
    return res.data.count ?? 0;
  } catch {
    return 0;
  }
}

// Admin: flip pre-launch / post-launch. Returns {ok, is_post_launch, error}
export async function setLaunch(isPostLaunch, token) {
  try {
    const res = await axios.post(`${API}/admin/launch`, { is_post_launch: isPostLaunch, token });
    return { ok: true, is_post_launch: !!res.data.is_post_launch };
  } catch (err) {
    const status = err?.response?.status;
    return { ok: false, error: status === 403 ? "Invalid passphrase." : "Could not update. Try again." };
  }
}

export function scrollToProgress(p) {
  const max = document.documentElement.scrollHeight - window.innerHeight;
  window.scrollTo({ top: max * p, behavior: "smooth" });
}
